import React, { useEffect, useState } from 'react';
import "./authentication.css";
import { Link, useNavigate } from 'react-router-dom';
import Countries from "../Data/Countries.json";
import { RegisterAPI } from '../../Service/API/Post';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Register() {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('+91');
  const [formData, setFormData] = useState({
    username: '',
    phoneNo: '',
    password: '',
    confirmPassword: '',
    inviteCode: '',
    isTerms: false,
    otpStatus: false,
    countryCode: '91',
  });

  const [error, setError] = useState({
    username: '',
    phoneNo: '',
    password: '',
    confirmPassword: '',
    inviteCode: '',
    isTerms: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    setCountries(Countries);
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
    setFormData({
      ...formData,
      countryCode: event.target.value.replace('+', '')
    });
  };
  
console.log("countrycode ",selectedCountry)
  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    setFormData({
      ...formData,

      isTerms: checked
    });
  };
 
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("formdata>>",formData)
    try {
      const res = await RegisterAPI(formData);
      console.log("REsponse>>",res)
      if (res.status === 200) {
        toast.success(res?.data?.message || 'Registration successful!');
        navigate("/login");
      } else {
        setError({
          username: res.response.data.errors.username || '',
          phoneNo: res.response.data.errors.phoneNo || '',
          password: res.response.data.errors.password || '',
          confirmPassword: res.response.data.errors.confirmPassword || '',
          inviteCode: res.response.data.errors.inviteCode || '',
          isTerms: res.response.data.errors.isTerms || ''
        });
      }
    } catch (error) {
      console.log("error", error.message)
    }
  };

  return (
    <>
      <div>
      <ToastContainer />

        <section className='register_outer'>
          <div className='container'>
            <div className='register_container'>
              <div className='register_head'>
                <div className='register_content_heading'>
                  <h3>Register</h3>
                  <p>Enter below details to register your account</p>
                </div>
                <div className='register_heading_button'>
                  <Link to="/home" className='register_back_navigation_btn'>Back Home</Link>
                </div>
              </div>
              <div className='register_border_bottom'></div>
              <div className='register_form_area'>
                <form onSubmit={handleSubmit}>
                  <div className='register_name_area input_outer'>
                    <label htmlFor='username'>Username</label>
                    <input
                      type='text'
                      name="username"
                      className='register_name_input'
                      placeholder='Enter Username'
                      value={formData.username}
                      onChange={handleChange}
                    />
                    {error.username && <p className="error-message">{error.username}</p>}
                  </div>
                  <div className='register_country_area'>
                    <label htmlFor='countryCode'>Country</label>
                    <select
                      name="countryCode"
                      className='register_country_input'
                      value={selectedCountry}
                      onChange={handleCountryChange}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country.code}>
                          {country.name} ({country.code})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='register_mobile_area input_outer'>
                    <label htmlFor='phoneNo'>Mobile Number</label>
                    <input
                      type='text'
                      name="phoneNo"
                      className='register_mobile_input'
                      placeholder='Enter Mobile number'
                      value={formData.phoneNo}
                      onChange={handleChange}
                    />
                    {error.phoneNo && <p className="error-message">{error.phoneNo}</p>}
                  </div>
                  <div className='register_password_area input_outer'>
                    <label htmlFor='password'>Password</label>
                    <div className="password-field">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        className='register_password_input'
                        placeholder='Enter Password'
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <span
                        className="password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {error.password && <p className="error-message">{error.password}</p>}
                  </div>
                  <div className='register_confirm_password_area input_outer'>
                    <label htmlFor='confirmPassword'>Confirm Password</label>
                    <div className="password-field">
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        name="confirmPassword"
                        className='register_confirm_password_input'
                        placeholder='Re Enter Password'
                        value={formData.confirmPassword}
                        onChange={handleChange}
                      />
                      <span
                        className="password-toggle"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {error.confirmPassword && <p className="error-message">{error.confirmPassword}</p>}
                  </div>
                  <div className='register_invitation_area input_outer'>
                    <label htmlFor='inviteCode'>Invitation Code</label>
                    <input
                      type='text'
                      name="inviteCode"
                      className='register_invitation_input'
                      placeholder='Enter Invitation Code'
                      value={formData.inviteCode}
                      onChange={handleChange}
                    />
                    {error.inviteCode && <p className="error-message">{error.inviteCode}</p>}
                  </div>

                  <div className='register_agree_area'>
                    <input
                      className="register_agree_check"
                      type="checkbox"
                      name="isTerms"
                      checked={formData.isTerms}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="agree">
                      Agree to Best Western's <Link to="/privacy-policy">Terms and Privacy</Link>.
                    </label>
                    {error.isTerms && <p className="error-message">{error.isTerms}</p>}
                  </div>

                  <div className='register_btn_area'>
                    <input
                      type='submit'
                      value='REGISTER'
                      className='register_submit_btn'
                    />
                  </div>
                  <div className='register_already_account_area'>
                    <p>Already have an account? <Link to="/login" className='registe_login_link'>Login</Link></p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
